var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFavouriteNormalWhiteDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.1632C0 8.57965 8.57965 0 19.1632 0H20.8368C31.4203 0 40 8.57965 40 19.1632C40 29.7467 31.4203 38.3264 20.8368 38.3264H19.1632C8.57965 38.3264 0 29.7467 0 19.1632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10.5391C22.76 10.5391 21.09 11.3152 20 12.5416C18.91 11.3152 17.24 10.5391 15.5 10.5391C12.42 10.5391 10 12.8578 10 15.8089C10 19.4308 13.4 22.3819 18.55 26.8661L20 28.1213L21.45 26.8565C26.6 22.3819 30 19.4308 30 15.8089C30 12.8578 27.58 10.5391 24.5 10.5391ZM20.1 25.4384L20 25.5342L19.9 25.4384C15.14 21.3088 12 18.578 12 15.8089C12 13.8926 13.5 12.4554 15.5 12.4554C17.04 12.4554 18.54 13.404 19.07 14.7166H20.94C21.46 13.404 22.96 12.4554 24.5 12.4554C26.5 12.4554 28 13.8926 28 15.8089C28 18.578 24.86 21.3088 20.1 25.4384Z",
    fill: "#0033AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouriteNormalWhiteDarkblue);
export default __webpack_public_path__ + "static/media/ic_favourite_normal_white_darkblue.e4640d2c3e0cc37be20bf03179b65444.svg";
export { ForwardRef as ReactComponent };